<template>
    <Mz-Dialog class="dialog" :title="title" width="3147px" :visible.sync="visible" @handleClose="handleClose">
        <div slot="content" class="main" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0,0,0,0)">
            <ul class="flx-bc btns">
                <li class="btn" :class="active===item.name?'active':''" @click="goDig('video',item)" v-for="(item,i) in data.videos" :key="i"><a>{{item.name}}</a></li>
                <li class="btn" :class="active===data.pdf.name?'active':''" @click="goDig('pdf')"><a>牦牛乳酪蛋白企业标准</a></li>
            </ul>
            <div v-if="digType==='video'" class="video">
                <video :src="digData.url" ref="videoPlayer" controls>
                    Your browser does not support the video tag.
                </video>
            </div>
             <div v-if="digType==='pdf'" class="box">
                <pdf v-for="item in numPages" :key="item" :src="pdfUrl" :page="item" ref="pdf"></pdf>
            </div>
        </div>
    </Mz-Dialog>
</template>

<script>
import echarts from 'echarts'
import pdf from 'vue-pdf'
import 'echarts/map/js/china'
    export default {
        components: {pdf},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
            data: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                loading: false,
                numPages: null, // pdf 总页数
                pdfUrl: '',
                active: this.data.videos[0].name,
                digType: 'video',
                digData: this.data.videos[0],
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            goDig(type,data){
                this.digType = type
                this.digShow = true
                if(type==='video'){
                    this.digData = data
                    this.active = data.name
                }else if(type==='pdf'){
                    this.pdfUrl = this.data.pdf.url
                    this.active = this.data.pdf.name
                    this.$nextTick(() => {
                        this.getNumPages()
                    })
                }
            },
            getNumPages() {
                this.loading = true
                let loadingTask = pdf.createLoadingTask(this.pdfUrl)
                loadingTask.promise.then(pdf => {
                    this.loading = false
                    this.numPages = pdf.numPages
                }).catch(err => {
                    this.loading = false
                    this.$message('pdf 加载失败，请重试')
                    console.error('pdf 加载失败', err);
                })
            },
            handleClose(){
                this.$emit('update:visible', false)
            }
        }
    }
</script>

<style lang="less" scoped>
@import '@/styles/ganzi';
.main{
    padding: 40px 300px;
    height: 1800px;
}
.box{
    width: 100%;
    height: 100%;
}
.video{
    width: 100%;
    text-align: center;
    video{
        width: 100%;
    }
}
.image{
    text-align: center;
    img{
        width: 100%;
    }
}
.active{
    background: #3e71a7 !important;
}
</style>